import { StandardDialogLabels } from '@brandfolder/react';

import { loaderLabel } from './loader';

export const getStandardDialogLabels = (labels: Partial<StandardDialogLabels> = {}): StandardDialogLabels => {
  return {
    closeButtonLabel: bfTranslate('Close'),
    loaderLabel,
    ...labels
  };
};
